import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router';
import { ThemeProvider, ToastProvider } from '@mieweb/ui';
import { App } from './App';
import { isDesktop, initDesktopDeepLinks, checkForDesktopUpdate } from './lib/desktop';
import './index.css';

// CSS has loaded — reveal the SSG content (removes FOUC guard)
document.documentElement.classList.add('fouc-ready');

// Tauri's asset protocol has no SPA fallback for deep paths, so the desktop
// build keeps the route in the URL fragment instead of the pathname.
const Router = isDesktop ? HashRouter : BrowserRouter;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <ThemeProvider defaultTheme="system">
        <ToastProvider>
          <App />
        </ToastProvider>
      </ThemeProvider>
    </Router>
  </StrictMode>
);

if (isDesktop) {
  // System-browser OAuth hands the one-time login code back via the
  // `pollenate://auth/callback` deep link; route it into the same
  // /auth/callback page the web flow uses (HashRouter → set the fragment).
  void initDesktopDeepLinks((code) => {
    window.location.hash = `/auth/callback?code=${encodeURIComponent(code)}`;
  });

  // Silent launch-time update check (prompts only when a new signed build is
  // available; failures retry on next launch).
  void checkForDesktopUpdate();
}

// Signal to prerenderer that the page is ready
document.dispatchEvent(new Event('prerender-ready'));
